import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Button, Heading, OverlayArrow, Text, Tooltip as TooltipAria, TooltipTrigger } from "react-aria-components";
import { icon } from "../icon.css.js";
import { HelpCircle } from "../icons/line.js";
import * as styles from "./Tooltip.css.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const BaseTooltip = (t0, ref) => {
  const $ = _c(29);
  let children;
  let props;
  let supportingText;
  let t1;
  let text;
  if ($[0] !== t0) {
    ({
      text,
      supportingText,
      children,
      theme: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = supportingText;
    $[4] = t1;
    $[5] = text;
  } else {
    children = $[1];
    props = $[2];
    supportingText = $[3];
    t1 = $[4];
    text = $[5];
  }
  const theme = t1 === undefined ? "dark" : t1;
  let isOpen;
  let tooltipProps;
  if ($[6] !== props) {
    ({
      isOpen,
      ...tooltipProps
    } = props);
    $[6] = props;
    $[7] = isOpen;
    $[8] = tooltipProps;
  } else {
    isOpen = $[7];
    tooltipProps = $[8];
  }
  let t2;
  if ($[9] !== theme) {
    t2 = styles.tooltip({
      theme
    });
    $[9] = theme;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== theme) {
    t3 = styles.overlayArrow({
      theme
    });
    $[11] = theme;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /*#__PURE__*/_jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "17",
      height: "9",
      viewBox: "0 0 17 9",
      className: styles.overlayArrowSvg,
      children: /*#__PURE__*/_jsx("path", {
        d: "M14.5711.485289c.8909 0 1.337 1.077141.7071 1.707111L9.20711 8.26347c-.39053.39053-1.02369.39053-1.41422 0L1.72183 2.1924c-.62996-.62997-.1838-1.707111.70711-1.707111H14.5711Z"
      })
    });
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3) {
    t5 = /*#__PURE__*/_jsx(OverlayArrow, {
      className: t3,
      children: t4
    });
    $[14] = t3;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== supportingText || $[17] !== text) {
    t6 = supportingText == null ? /*#__PURE__*/_jsx(Text, {
      slot: "description",
      className: styles.tooltipTextHeader,
      children: text
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Heading, {
        slot: "header",
        className: styles.tooltipTextHeader,
        children: text
      }), /*#__PURE__*/_jsx(Text, {
        slot: "description",
        className: styles.tooltipTextSupporting,
        children: supportingText
      })]
    });
    $[16] = supportingText;
    $[17] = text;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== ref || $[20] !== t2 || $[21] !== t5 || $[22] !== t6 || $[23] !== tooltipProps) {
    t7 = /*#__PURE__*/_jsxs(TooltipAria, {
      offset: styles.tooltipGap + styles.overlayArrowHeight,
      className: t2,
      ...tooltipProps,
      ref: ref,
      children: [t5, t6]
    });
    $[19] = ref;
    $[20] = t2;
    $[21] = t5;
    $[22] = t6;
    $[23] = tooltipProps;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== children || $[26] !== isOpen || $[27] !== t7) {
    t8 = /*#__PURE__*/_jsxs(TooltipTrigger, {
      isOpen: isOpen,
      delay: 0,
      children: [children, t7]
    });
    $[25] = children;
    $[26] = isOpen;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
};
export const Tooltip = /*#__PURE__*/React.forwardRef(BaseTooltip);
export const TooltipIcon = t0 => {
  const $ = _c(10);
  const {
    color,
    size: t1
  } = t0;
  const size = t1 === undefined ? "s" : t1;
  let t2;
  if ($[0] !== color || $[1] !== size) {
    t2 = styles.helpIcon({
      size,
      color
    });
    $[0] = color;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== size) {
    t3 = icon({
      size
    });
    $[3] = size;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = /*#__PURE__*/_jsx(HelpCircle, {
      className: t3
    });
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = /*#__PURE__*/_jsx(Button, {
      className: t2,
      children: t4
    });
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
//# sourceMappingURL=Tooltip.js.map